import React from 'react';
import { useInView } from 'react-intersection-observer';

export function LazyComponent(props) {

    const { negativeMarginTop } = getRootoffSetMargins();

    const { ref, inView, entry } = useInView({
        triggerOnce: true,
        threshold: 0,
        rootMargin: `${negativeMarginTop} 0px 0px 0px`
    });

    const {component: Component, loadImmediately: LoadImmediately = false} = props;

    // const Component = props.component;
    // const LoadImmediately = props.loadImmediately ?? false;

    if(!inView && !LoadImmediately) return (
        <div ref={ref} className="component-loading">
            Loading...
        </div>
    );

    return (
        <Component rootElement={ props.rootElement}></Component>
    )
};

function getRootoffSetMargins() {
    const HeaderHeight = Math.round(
        document.querySelector(".root .sticky-wrapper")?.getBoundingClientRect().height ?? 0
    );
    const offsetFromBottomOfHeader = 90 + (window.innerWidth > 576 ? 30 : 44);
    const VisibleScrollableHeight = window.innerHeight - (HeaderHeight + offsetFromBottomOfHeader); // (minus offset)
    const negativeMarginTop = (HeaderHeight + offsetFromBottomOfHeader) * -1 + "px";
    const negativeMarginBottom = (VisibleScrollableHeight - 2) * -1 + "px";
    return { negativeMarginTop, negativeMarginBottom };
}